import { Account } from './Account.type';
import { JobConfirmation } from './JobConfirmation.type';
import { CEOProfile, ManagerProfile } from './ManagerProfile.type';
import { Role } from './Role.type';
import { WorkerProfile } from './WorkerProfile.type';

export enum ORG_TYPE {
  COMPANY = 'COMPANY',
  STUDENT_ORG = 'STUDENT_ORG',
}

export enum FeatureFlagKey {
  FACEBOOK_AI = 'facebookAi',
  AVAILABLE_WORKERS = 'availableWorkers',
}

export interface Company {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  active: boolean;
  addressLine1: string;
  city: string;
  country: string;
  email: string;
  name: string;
  number: string;
  postCode: string;
  rake: string;
  ceo: CEOProfile;
  managers: ManagerProfile[];
  workers: WorkerProfile[];
  roles: Role[];
  confirmations: JobConfirmation[];
  vatNumber: string;
  account?: Account;
  jobConfirmationsNeeded: boolean;
  organizationType: ORG_TYPE;
  featureFlags?: FeatureFlagKey[];
}
